import { Pipe, PipeTransform } from '@angular/core';
import { ProspectData } from '../../../core-data-model';

@Pipe({
    name: 'demoUserDataDisplayById',
    standalone: true
})
export class DemoUserDataDisplayByIdPipe implements PipeTransform {
    transform(value: string, results: ProspectData[]): string {
        const result = results.find((r) => r.surveyUserId === value);

        if (result) {
            const formattedName =
                `${result.firstName} ${result.lastName}`.trim();

            return result.firstName || result.lastName
                ? `${formattedName} (${result.email})`
                : result.email;
        }

        return '';
    }
}
